<template>
    <div class="home">
        <van-image fit="contain" :src="require('@img/banner_home@2x.jpg')" width="100%"></van-image>
        <div class="top-links">
            <!--<van-grid :column-num="3" :border="false">
                <van-grid-item
                    v-for="(item, index) in topLinks"
                    :key="index"
                    :icon="require(`@img/${item.icon}`)"
                    :text="item.text"
                    @click="routingTo(item.link)"
                />
            </van-grid>-->
            <ul>
                <li v-for="(item, index) in topLinks" @click="routingTo(item.link)" :key="index">
                    <img :src="require(`@img/${item.icon}`)">
                    <span>{{item.text}}</span>
                </li>
            </ul>
        </div>
        <span class="blank"></span>
        <ul class="link-btn-2">
            <li v-for="(item, index) in linkBtn2" :key="index" @click="routingTo(item.link)">
                <div><p>{{item.text}}</p><span>{{item.description}}</span></div>
                <img :src="require(`@img/${item.icon}`)">
            </li>
        </ul>
        <span class="blank"></span>
        <!--2021年9月29日-页面上隐藏掉知识问答和合作楼盘，微信和H5-->
        <!--<ul class="link-btn-2">
            <li v-for="(item, index) in linkBtn3" :key="index" @click="routingTo(item.link)">
                <div><p>{{item.text}}</p><span>{{item.description}}</span></div>
                <img :src="require(`@img/${item.icon}`)">
            </li>
        </ul>
        <span class="blank"></span>-->
        <div class="link-btn-4">
            <ul>
                <li v-for="(item, index) in bottomLinks" :key="index" @click="routingTo(item.link)">
                    <img :src="require(`@img/${item.icon}`)" alt="">
                    <span>{{item.text}}</span>
                </li>
            </ul>
        </div>
        <footer>南通市住房公积金提供服务</footer>
    </div>
</template>

<script>
    import { Image,Grid, GridItem } from 'vant';
    import { encrypt, decrypt } from '@/plugins/JsEncrypt/sm4Util';
    import 'vant/es/image/style';
    import 'vant/es/grid/style';
    import 'vant/es/grid-item/style';
    import store from '@center/store'

    export default {
        name: "home",
        components: {
            vanImage: Image,
            vanGrid: Grid,
            vanGridItem: GridItem
        },
        mounted() {
            let self = this;
            console.log('accountNumber===> ', self.$store.state.accountNumber)
            if(!self.$store.state.accountNumber){
                this.BTinit();
            }
        },
        data() {
            return {
                topLinks: [
                    {
                        text: '我的公积金', //账户查询
                        icon: 'btn_home_wdgjj@2x.png',
                        link: 'accountQuery'
                    },
                    {
                        text: '我的贷款', //贷款查询
                        icon: 'btn_home_wddk@2x.png',
                        link: 'loanQuery'
                    },
                    {
                        text: '提取业务',
                        icon: 'btn_home_tqyw@2x.png',
                        link: 'extractQuery'
                    }
                ],
                linkBtn2: [
                    {
                        text: '服务指南',
                        description: '业务流程 常见问题',
                        icon: 'icon_home_fwzn@2x.png',
                        link: 'serviceGuide'
                    },
                    //2021年9月29日-页面上隐藏掉知识问答和合作楼盘，微信和H5
                    /*{
                        text: '合作楼盘',
                        description: '楼盘信息 可贷栋号',
                        icon: 'icon_home_hzlp@2x.png',
                        link: 'estate'
                    }*/
                    {
                        text: '网点查询',
                        description: '附近网点 就近服务',
                        icon: 'icon_home_wdcx@2x.png',
                        link: 'branch'
                    }
                ],
                linkBtn3: [
                    {
                        text: '知识问答',
                        description: '常见问题 详细解答',
                        icon: 'icon_home_zswd@2x.png',
                        link: 'knowledge'
                    },
                    {
                        text: '网点查询',
                        description: '附近网点 就近服务',
                        icon: 'icon_home_wdcx@2x.png',
                        link: 'branch'
                    }
                ],
                bottomLinks: [
                    {
                        text: '网上签约', //账户查询
                        icon: 'icon_home_wsqy@2x.png',
                        link: 'onlineSign'
                    },
                    {
                        text: '银行卡绑定', //贷款查询
                        icon: 'icon_home_yhkbd@2x.png',
                        link: 'bindCard'
                    },
                    {
                        text: '密码修改',
                        icon: 'icon_home_gjjmmxg@2x.png',
                        link: 'changePwd'
                    }
                ],
                isreload: '',
                appId: '21ccd04bbcc647699d38a91347594fb2',
                initCode: '',
                resA5003: null,
                accountNum: '',
                start_time: '',
            };
        },
        created: function(){
            // 是否做了绑定/解绑银行卡
            if(!!sessionStorage.getItem('isbind')){
                sessionStorage.removeItem('isbind');
                window.location.reload();
            }
            this.start_time = new Date().getTime();
            console.log('接口开始请求时间 -> ', this.start_time);
        },
        methods: {
            /*
* 百通初始化
* */
            BTinit(){
                let self = this;
                //A5001
                self.getInitCode(function(initCode){
                    self.initCode = initCode;
                    console.log('self.appId -> ', self.appId);
                    //注入权限验证配置
                    window.sc.config({
                        debug: false,
                        appId: self.appId,
                        initCode: initCode,
                        nativeApis: ['phoneCall', 'nativeRoute', 'sms', 'contact', 'gps', 'navigation', 'qrCode', 'chooseImage', 'openLocation' ]
                    });
                    console.log('doready');
                    window.sc.ready(() => {
                        window.sc.userAuth({ appId: self.appId }, res => {
                            /*
                             sc.userAuth会首先判断用户是否登录，若没有登录，则会主动调起登录窗口，
                             无需在此调用 isLogin 和 login 接口
                            */
                            if (res.code === 0) {
                                //    用户同意授权
                                // const requestCode = res.data.requestCode
                                /*fetchUserInfo(requestCode).then(info => {
                                    console.log({ info })
                                    // 你自己的业务逻辑
                                })*/
                                self.requestCode = res.data.requestCode;
                                //2、获取userAccessToken  A5002
                                self.getUserAccessToken(res.data.requestCode, res => {
                                    if(res.recode === '000000'){
                                        self.userAccessToken = res.data.userAccessToken;
                                        self.$store.commit('setBtInfo', {
                                            initCode: self.initCode,
                                            accessToken: '',
                                            requestCode: self.requestCode,
                                            userAccessToken: res.data.userAccessToken
                                        });
                                        //window.alert(JSON.stringify(Store.state.baitong));
                                        //window.alert(JSON.stringify(_this.$store.state.baitong));

                                        //3、根据userAccessToken获取用户信息  A5003
                                        self.getBtAccountInfo(self.userAccessToken, res => {
                                            res = typeof res === 'string' ? JSON.parse(res) : res;
                                            console.log(res.recode === '000000');
                                            if(res.recode === '000000') {
                                                /*_this.$store.commit('setBtUserInfo', {
                                                    idCard: res.data.iDcard,
                                                    openId: res.data.openId,
                                                    userName: res.data.userName,
                                                });*/

                                                let resA5003 = res.data;
                                                self.resA5003 = resA5003;
                                                store.commit('setBtUserInfo', {
                                                    idCard: resA5003.iDcard
                                                })
                                                console.log('store.state.btUserInfo ->', store.state.btUserInfo)
                                                self.$utils.loading(false);
                                                //测试用的身份证号：
                                                // resA5003.iDcard = '320681198407037633'; // 退休提取

                                                //4、获取公积金账号
                                                self.$http.post('/miapp/A5004/mpaasgatewayunencrypted', {
                                                    __openid: resA5003.iDcard,
                                                    ybmapMessage: {
                                                        zjhm: encrypt(resA5003.iDcard),
                                                        dllx: encrypt('2')
                                                    },
                                                    isSm4:'1'
                                                }).then(res => {

                                                    if(res.recode === '000000'){
                                                        self.$store.commit('setAccountNumber', {
                                                            accountNumber: decrypt(res.grzh),
                                                        });
                                                        self.$store.commit('setBtUserInfo', {
                                                            idCard: resA5003.iDcard,
                                                            openId: resA5003.openId,
                                                            userName: decrypt(res.username),
                                                            coreUserid: decrypt(res.coreUserid),
                                                            yhzh: decrypt(res.glyhkh),
                                                            yhbm: decrypt(res.cbank),
                                                            zjlx: decrypt(res.zjlx),
                                                            zjhm: decrypt(res.zjhm),
                                                            tel: decrypt(res.sjhm),
                                                            dwzh: decrypt(res.dwzh),
                                                            gryjce: decrypt(res.gryjce),
                                                            dwyjce: decrypt(res.dwyjce),
                                                            btyje: decrypt(res.btyje),
                                                            cardno: decrypt(res.glyhkh),
                                                            bank: decrypt(res.glyh)
                                                        });
                                                        console.log(self.$store.state.accountNumber);

                                                    } else {
                                                        self.$utils.loading(false);
                                                        self.$utils.alert(res.msg);
                                                    }

                                                    /*function systemType(){
                                                        let u = navigator.userAgent;
                                                        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                                                        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                                                        if(isAndroid){
                                                            return 'android';
                                                        }
                                                        if(isiOS){
                                                            return 'ios';
                                                        }
                                                    }*/
                                                    // 获取经纬度
                                                    window.sc.gps(function(res) {
                                                        self.$utils.loading(false);
                                                        console.log('---开始获取的经纬度---');
                                                        console.log(res);
                                                        console.log('---获取的经纬度完成---');
                                                        self.$store.commit('setPos', {
                                                            lng: res.data.longitude,
                                                            lat: res.data.latitude
                                                        });
                                                        console.log('接口请求结束时间 -> ', new Date().getTime());
                                                        console.log('请求4个接口总消耗时间 -> ' + (new Date().getTime() - self.start_time) + ' ms');
                                                    });
                                                }).catch(res => {
                                                    self.$utils.loading(false);
                                                    console.log("error", res);
                                                });
                                            } else {
                                                self.$utils.loading(false);
                                                self.$utils.alert(res.msg);
                                                console.log(res.msg);
                                            }
                                            console.log(res);
                                        });
                                    } else {
                                        self.$utils.alert(res.msg);
                                        console.log(res.msg);
                                        self.$utils.loading(false);
                                    }
                                });
                            } else {
                                /*
                                用户拒绝授权或其它失败情况
                                code: -1 默认失败
                                code: -10001    没有初始化JSSDK
                                code: -10002    用户点击拒绝授权
                                code: -10003    用户未登录
                                */
                                self.$utils.loading(false);
                                self.$utils.alert(res.message);
                                console.log(res.message);

                            }
                        })
                    });
                    window.sc.error((res) => {
                        // self.alert(res.message);
                        console.log(res);
                        self.$utils.loading(false);
                    });
                });
            },
            /*
            * 南通百通获取initCode
            * */
            getInitCode(suc){
                let self = this;
                let initCode = '';
                self.$http.post('/miapp/A5001/mpaasgatewayunencrypted', {

                })
                    .then(function (res) {
                        initCode = res.recode === '000000' ? res.initCode.initCode : '';
                        suc(initCode);
                    })
                    .catch(function (res) {
                        console.log("error", res);
                    });
            },
            /*
            * 南通百通获取userAccessToken
            * */
            getUserAccessToken(requestCode, suc){
                let self = this;
                self.$http.post('/miapp/A5002/mpaasgatewayunencrypted', {
                    requestCode: requestCode
                })
                    .then(res => {
                        suc(res);
                    })
                    .catch(function (res) {
                        console.log("error", res);
                    });
            },
            /*
            * 南通百通获取用户信息
            * */
            getBtAccountInfo(userAccessToken, suc){
                let self = this;
                self.$http.post('/miapp/A5003/mpaasgatewayunencrypted', {
                    userAccessToken: userAccessToken
                })
                    .then(res => {
                        suc(res);
                    })
                    .catch(function (res) {
                        console.log("error", res);
                    });
            },


            routingTo(target){
                let self = this;
                let tar = target;
                // self.$utils.loading(true);

                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid'
                    }
                });

                /*if(!self.$store.state.accountNumber.accountNumber){
                    getUserinfo();
                } else {
                    self.$router.push({
                        path: '/' + target,
                        query: {
                            'openweb': 'paschybrid'
                        }
                    });
                    self.$utils.loading(false);
                }*/

                function getUserinfo(){
                    self.$http.post('/miapp/A5004/mpaasgatewayunencrypted', {
                        ybmapMessage: {
                            zjhm: encrypt(self.resA5003.iDcard),
                            // zjhm: '320623199208135610',
                            dllx: encrypt('2'),
                            pwd: encrypt('12345678'),
                            yzm: encrypt('123456')
                        },
                        isSm4:'1'
                    }).then(res => {

                        if(res.recode === '000000'){
                            self.$store.commit('setAccountNumber', {
                                accountNumber: res.grzh,
                            });
                            self.$store.commit('setBtUserInfo', {
                                idCard: self.resA5003.iDcard,
                                openId: self.resA5003.openId,
                                userName: res.username,
                                coreUserid: res.coreUserid,
                                yhzh: res.glyhkh,
                                yhbm: res.cbank,
                                zjlx: res.zjlx,
                                zjhm: res.zjhm,
                                tel: res.sjhm,
                                dwzh: res.dwzh,
                                gryjce: res.gryjce,
                                dwyjce: res.dwyjce,
                                btyje: res.btyje,

                                cardno: res.glyhkh,
                                bank: res.glyh
                            });
                            console.log(self.$store.state.accountNumber);

                        } else {
                            self.$utils.loading(false);
                            self.$utils.alert(res.msg);
                        }

                        // 获取经纬度
                        window.sc.gps(function(res) {
                            self.$utils.loading(false);
                            console.log('---开始获取的经纬度---');
                            console.log(res);
                            console.log('---获取的经纬度完成---');
                            self.$store.commit('setPos', {
                                lng: res.data.longitude,
                                lat: res.data.latitude
                            });
                        });
                        self.$router.push({
                            path: '/' + target,
                            query: {
                                'openweb': 'paschybrid'
                            }
                        });
                    }).catch(res => {
                        self.$utils.loading(false);
                        console.log("error", res);
                    });
                }


                /*function doroute(tar) {
                    self.$router.push({
                        path: '/' + target,
                        query: {
                            'openweb': 'paschybrid'
                        }
                    });
                }*/
            }
        }
    };
</script>
<style lang="stylus">
body
    background #e5e5e5
</style>
<style lang="stylus" scoped>
.banner
    width 100%
    display block
.van-image
    display block
.top-links
    setbg(#fff)
    padding 0 .3rem
    ul
        width 100%
        display flex
        justify-content space-between
        align-items center
        padding .3rem 0
        li
            width 31%
            padding 0 1%
            img
                width 30.6%
                display block
                margin 0 auto
            span
                text-align center
                display block
                font-size .28rem
                padding-top .2rem
                color #7d7e80
.blank
    width 100%
    height .2rem
    background #e5e5e5
    display block
.link-btn-2
    setbg(#fff)
    display flex
    width 100%
    padding .2rem 0
    li
        width 50%
        display flex
        justify-content space-between
        align-items center
        border-right solid 1px #e5e5e5
        padding 0 .2rem 0 .3rem
        &:last-child
            border none
        img
            display block
            width 20%
        div
            padding .2rem 0
            p
                font-size .3rem
            span
                font-size .28rem
                color #999
                padding-top .1rem
                display block
.link-btn-3
    position relative
    img
        display block
        width 100%
    p
        font-size .32rem
        position absolute
        top .34rem
        left .7rem
        z-index 2
    span
        font-size .28rem
        color #999
        padding-top .2rem
        position absolute
        top .63rem
        left .7rem
        z-index 2
.link-btn-4
    setbg(#fff)
    padding .22rem 0.3rem
    ul
        display flex
        justify-content space-between
        align-items center
        li
            padding .2rem 0
            width 30.4%
            border-radius 5px
            &:first-child
                background #eef9ff
            &:nth-child(2)
                background #fff6e8
            &:last-child
                background #f3f6ff
            img
                display block
                width 40%
                margin 0 auto
            span
                font-size .28rem
                padding-top .14rem
                display block
                text-align center
footer
    width 100%
    font-size .26rem
    color #666
    display block
    text-align center
    line-height .8rem
</style>